<template>
  <div class="container_box details_box_styles">
    <!--活动信息-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1005104') }}</h2>
        </template>
        <Form ref="activityInfo" class="form_box_style" :model="activityInfo" :label-width="150" :rules="ruleValidate" @submit.native.prevent>
          <Row type="flex" :gutter="gutterItem">
            <languagesTabs ref="languagesTab" :tabsList="multilingualNamesList">
              <template v-for="item in multilingualNamesList">
                <template :slot="item.name">
                  <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
                    <Form-item :label="labelRander(item, 'activityTitle')" :prop="'activityTitle_' + item.code" :rules="getRules(item)">
                      <Input placeholder="" v-model.trim="activityInfo['activityTitle_' + item.code]" clearable style="width: 400px;"></Input>
                    </Form-item>
                  </Col>
                  <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" class="tooltip_styles">
                    <Tooltip class="slogan_tips" transfer placement="top-start" max-width="1400">
                      <Icon type="md-help-circle" size="16" color="#7F7F7F"/>
                      <template #content>
                        <img :src="activity_slogan_img" alt="">
                      </template>
                    </Tooltip>
                    <Form-item :label-width="setSloganLabelWidth" :label="labelRander(item, 'activitySlogan')" :prop="'activitySlogan_' + item.code">
                      <Input placeholder="" v-model.trim="activityInfo['activitySlogan_' + item.code]" clearable style="width: 400px;"></Input>
                    </Form-item>
                  </Col>
                  <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" class="tooltip_styles">
                    <Tooltip class="activityLabel_tips" transfer placement="top" max-width="350">
                      <Icon type="md-help-circle" size="16" color="#7F7F7F"/>
                      <template #content>
                        <img :src="activity_label_img" alt="">
                      </template>
                    </Tooltip>
                    <Form-item :label-width="setLabelWidth" :label="labelRander(item, 'activityGoodsLabel')" :prop="'activityGoodsLabel_' + item.code">
                      <Input placeholder="" v-model.trim="activityInfo['activityGoodsLabel_' + item.code]" clearable style="width: 400px;"></Input>
                    </Form-item>
                  </Col>
                  <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
                    <FormItem :label="labelRander(item, 'imagePath')" :prop="'imagePath_' + item.code">
                      <Upload
                        style="width: 400px;"
                        type="drag"
                        name="files"
                        :headers="headObj"
                        :action="fileApi"
                        :data="uploadData"
                        :show-upload-list="false"
                        :on-success="(response, file, fileList)=> uploadSuccess(response, file, fileList, item)"
                        :format="['jpg', 'jpeg', 'png', 'gif', 'bmp']"
                        :max-size="20480"
                        :on-format-error="handleFormatError"
                        :on-exceeded-size="handleMaxSize">
                        <div class="img_style" v-if="activityInfo['imagePath_' + item.code]">
                          <img style="width: 80%; height: auto; display: inline-block" :src="setImgPath(activityInfo['imagePath_' + item.code])" alt=""/>
                        </div>
                        <div v-else>
                          <Icon type="ios-cloud-upload" size="42" class="mt10" style="color: #3399ff"></Icon>
                          <p>{{ $t('key1005046') }}</p>
                          <span class="tips_txt">{{ $t('key1005105') }}</span>
                        </div>
                      </Upload>
                    </FormItem>
                  </Col>
                </template>
              </template>
            </languagesTabs>
            <Divider/>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <Form-item :label="$t('key1005093')" prop="newTab">
                <div class="flex align-items-center">
                  <RadioGroup v-model="activityInfo.newTab" type="button" button-style="solid">
                    <Radio :label="1">{{ $t('key1000392') }}</Radio>
                    <Radio :label="0">{{ $t('key1000393') }}</Radio>
                  </RadioGroup>
                  <Tooltip transfer placement="top-start" max-width="1400" class="ml10">
                    <Icon type="md-help-circle" size="17" color="#7F7F7F" class="cursor"/>
                    <template #content>
                      <img :src="activity_tab_img" alt="">
                    </template>
                  </Tooltip>
                </div>
              </Form-item>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <Form-item :label="$t('key1005094')" prop="isShowSupplierInfo">
                <div class="flex align-items-center">
                  <RadioGroup v-model="activityInfo.isShowSupplierInfo" type="button" button-style="solid">
                    <Radio :label="1">{{ $t('key1000392') }}</Radio>
                    <Radio :label="0">{{ $t('key1000393') }}</Radio>
                  </RadioGroup>
                </div>
              </Form-item>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <Form-item :label="$t('key1005095')" prop="activityStartTime">
                <DatePicker
                  v-model="activityInfo.activityStartTime"
                  type="datetime"
                  @on-change="(value)=> selectDate(value,'start')"
                  @on-clear="resetDate('start')"
                  :placeholder="$t('key1005096')"
                  format="yyyy-MM-dd HH:mm:ss"
                  style="width: 400px;">
                </DatePicker>
              </Form-item>
            </Col>
            <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
              <Form-item :label="$t('key1005097')" prop="activityEndTime">
                <div class="activity_longTerm_style">
                  <DatePicker
                    :disabled="activityInfo.effectivenessStatus === 1 || !activityInfo.activityStartTime"
                    type="datetime"
                    @on-change="(value)=> selectDate(value,'end')"
                    @on-clear="resetDate('end')"
                    :placeholder="$t('key1005098')"
                    format="yyyy-MM-dd HH:mm:ss"
                    :options="endOptions"
                    :editable="false"
                    :timePickerOptions="timePickerOptions"
                    v-model="activityInfo.activityEndTime"
                    style="width: 400px;">
                  </DatePicker>
                  <Checkbox v-model="activityInfo.effectivenessStatus" :false-value="0" :true-value="1" class="ml20">{{ $t('key1005021') }}</Checkbox>
                </div>
              </Form-item>
            </Col>
          </Row>
        </Form>
      </Card>
    </div>
    <!--活动定价-->
    <div class="basic_information_box" v-if="activityInfo.matchRule === 0">
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1005106') }}</h2>
        </template>
        <Form ref="activityPricing" class="form_box_style" :model="activityPricing" :label-width="150" @submit.native.prevent>
          <Row type="flex" :gutter="gutterItem" style="width: 60%">
            <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol">
              <Form-item :label="$t('key1005099')" prop="uniformPrice">
                <RadioGroup v-model="activityPricing.uniformPrice">
                  <Radio :label="1">{{ $t('key1000392') }}</Radio>
                  <Radio :label="0">{{ $t('key1000393') }}</Radio>
                </RadioGroup>
              </Form-item>
            </Col>
            <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol">
              <Form-item :label="$t('key1005092') + currencyState + ')：'" prop="uniformPriceValue">
                <InputNumber :max="999999999" :min="0" :formatter="(value) => formatterNumber(value, 2)" style="width: 100%"
                  v-model="activityPricing.uniformPriceValue" :disabled="activityPricing.uniformPrice === 0"></InputNumber>
              </Form-item>
            </Col>
          </Row>
        </Form>
      </Card>
    </div>
    <!--活动商品-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title>
          <div class="flex justify-content-between">
            <div class="flex align-items-center">
              <h2 class="title_box mr12">{{ $t('key1005107') }}</h2>
              <RadioGroup v-model="activityInfo.matchRule">
                <Radio v-for="item in matchRuleList" :disabled="activityInfo.isShowSupplierInfo === 0" :label="item.value">
                  {{ item.name }}
                </Radio>
              </RadioGroup>
            </div>
            <div class="flex align-items-center">
              <Button v-if="activityInfo.matchRule === 1" type="primary" @click="configureMatchingRulesModal = true">{{ $t('key1005108') }}</Button>
              <Button v-if="activityInfo.matchRule === 0" class="mr15" type="error" @click="removalBtn('all')"
                :disabled="ymsProductIdList.length<=0">{{ $t('key1005109') }}</Button>
              <Button v-if="activityInfo.matchRule === 0" type="primary"
                @click="addGoodsBtn">{{ $t('key1001092') }}</Button>
            </div>
          </div>
        </template>
        <!--列表区域-->
        <div class="table_box" v-if="activityInfo.matchRule === 0">
          <Table
            ref="selection"
            highlight-row
            border
            max-height="520"
            :loading="tableLoading"
            :columns="tableColumns"
            @on-selection-change="tableChange"
            :data="pageTableData">
          </Table>
          <Page
            :transfer="true"
            v-if="!tableLoading"
            :total="tableData.length"
            :current="page.pageNum"
            :page-size="page.pageSize"
            show-total
            show-sizer
            show-elevator
            placement="top"
            @on-change="localChangePage"
            @on-page-size-change="localChangePageSize"
            :page-size-opts="pageArray"/>
          <!--分页区域-->
          <div class="flex align-items-center mt20">
            <div>{{ $t('key1000365') + tableData.length + $t('key1001120') }}</div>
          </div>
        </div>
        <div v-else>
          <Row type="flex" :gutter="gutterItem">
            <Col :span="ItemCol" class="basic_item">
              <span class="basic_title">{{ $t('key1005101') }}</span>
              <span class="basic_txt">{{ activityInfo.matchRuleTypeName }}</span>
            </Col>
            <Col :span="ItemCol" class="basic_item">
              <span class="basic_title">{{ $t('key1005102') }}</span>
              <span class="basic_txt">{{ activityInfo.matchRuleDays }}</span>
            </Col>
          </Row>
        </div>
      </Card>
    </div>
    <!--底部操作按钮-->
    <div class="options_content">
      <Button class="mr15" @click="activityCancelBtn">{{ $t('key1000112') }}</Button>
      <Button class="mr15" type="primary" @click="activityBtn"
        v-if="getPermission('ymsActivityPlan_update') || getPermission('ymsActivityPlan_save')">{{ $t('key1000555') }}</Button>
    </div>
    <!--配置匹配规则弹窗-->
    <Modal v-model="configureMatchingRulesModal" :title="$t('key1005100')" width="500" :transfer="false" :mask-closable="false">
      <Form ref="configureMatchingRulesForm" :model="configureMatchingRulesForm"
        :rules="configureValidate" :label-width="75" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem" style="width: 80%">
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1005101')" prop="matchRuleType">
              <Select v-model="configureMatchingRulesForm.matchRuleType" transfer>
                <Option v-for="(item, index) in matchingRulesList" :value="item.value" :key="index">{{ item.name }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1005102')" prop="matchRuleValue">
              <div class="flex align-items-center">
                <InputNumber :max="99999" :min="0" :step="1" :formatter="value => `${parseInt(value)}`" style="width: 100px"
                  v-model="configureMatchingRulesForm.matchRuleValue"></InputNumber>
                <span style="margin-left: 8px;">{{ $t('key1001631') }}</span>
              </div>
            </Form-item>
          </Col>
        </Row>
        <div style="color: #9a9797; margin-left: 8px;">
          {{ $t('key1005110') }}<br/>
          {{ $t('key1005111') }}
        </div>
      </Form>
      <template #footer>
        <Button @click="configureMatchingRulesModal = false">{{ $t('key1000112') }}</Button>
        <Button type="primary" @click="configureMatchingRulesBtn">{{ $t('key1000111') }}</Button>
      </template>
    </Modal>
    <!--添加商品的弹窗-->
    <addCommonProductModal
      ref="addCommonProduct"
      :apiUrl="apiUrl"
      systemType="yms"
      @updateGoodsData="updateGoodsData">
    </addCommonProductModal>
    <!--提示框-->
    <Modal v-model="promptBoxModal" :title="$t('key1005103')">
      <h2 class="title">{{ $t('key1005112') }}</h2>
      <template #footer>
        <Button @click="promptBoxModal = false">{{ $t('key1000112') }}</Button>
        <Button type="error" @click="promptBoxBtn">{{ $t('key1005113') }}</Button>
      </template>
    </Modal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import api from '@/api/';
import addCommonProductModal from "@/components/common/addCommonProductModal";
import languagesTabs from "@/components/common/languagesTabs.vue";
import {formatterNumber, getDataSetBatchList, setConfigCharacters, getEnumList, isChineseLanguage} from "@/utils/common";

export default {
  name: "editActivity",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      apiUrl: api.post_ymsProductInfo_queryProductPageInfo,
      page: {
        pageNum: 1,
        pageSize: 10,
      },
      ItemCol: 24,
      activity_slogan_img: require('@/assets/images/activity_slogan_img.png'),
      activity_tab_img: require('@/assets/images/activity_tab_img.png'),
      activity_label_img: require('@/assets/images/activity_label_img.png'),
      fileApi: api.erpCommon_uploadFiles + '?basePath=yms-core-service&action="uploadimage"',
      uploadData: {},
      endOptions: {
        disabledDate: (date) => {
          let data = v.activityInfo.activityStartTime ? v.activityInfo.activityStartTime : null;
          return date < data;
        }
      },
      timePickerOptions: {
        disabledHours: [],
        disabledMinutes: [],
        disabledSeconds: []
      },
      startTime: null,
      endTime: null,
      // 活动信息
      activityInfo: {
        activityStartTime: null, // 活动开始时间
        activityEndTime: null, // 活动结束时间
        newTab: 0, // 是否新增为首页tab  0 否, 1 是
        isShowSupplierInfo: 1, // 是否显示供应商信息 0 否, 1 是
        effectivenessStatus: 0, // 0 指定时间, 1长期有效
        ymsProductIds: [], // 参与活动商品集
        status: 0, // 0 未开始 1 进行中 2已结束
        matchRule: 0, // 0 指定商品 1 配置规则匹配
        matchRuleTypeName: '', // 匹配规则
        matchRuleDays: '', // 天数
      },
      // 活动定价
      activityPricing: {
        uniformPrice: 0, // 是否统一设置价格 0 否  1 是
        uniformPriceValue: null // 统一定价
      },
      ruleValidate: {
        activityStartTime: [
          {required: true, type: 'date', message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005080'), trigger: 'change'}
        ],
        activityEndTime: [
          {required: true, type: 'date', validator: v.validateActivityTime(), trigger: 'change'}
        ]
      },
      tableColumns: [
        {
          type: 'selection',
          width: 60,
          fixed: 'left',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000383'),
          key: 'commodityInfo',
          align: 'center',
          minWidth: 240,
          render(h, params) {
            let list = [
              v.tableImg(h, params, 'primaryImage'),
              h('div', {
                class: 'text-align-left pl10'
              }, [
                h('Alink', {
                  props: {
                    linkName: params.row.name,
                    textAlign: 'left',
                    className: 'mb5'
                  },
                  on: {
                    AlinkBtn: () => {
                      v.toShopDetails(params.row.ymsProductId);
                    }
                  }
                }),
                h('p', {class: 'flex align-items-center'}, `${setConfigCharacters(false)}SPU：` + params.row.ymsSpu),
                h('p', {class: 'flex align-items-center'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000600') + params.row.supplierSpu),
              ])
            ];
            return h('div', {
              class: 'flex ptb10',
            }, list);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001098'),
          key: 'supplierMerchantId',
          minWidth: 110,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001101'),
          key: 'supplierMerchantIdName',
          align: 'center',
          minWidth: 110
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000882'),
          key: 'supplyPrice',
          minWidth: 140,
          align: 'center',
          render(h, params) {
            let maxSuggestPrice = params.row.maxSuggestPrice;
            let minSuggestPrice = params.row.minSuggestPrice;
            let price = '';
            if (maxSuggestPrice && minSuggestPrice) {
              price = minSuggestPrice + ' ~ ' + maxSuggestPrice;
            } else {
              price = '';
            }
            if (maxSuggestPrice && !minSuggestPrice) {
              price = maxSuggestPrice;
            }
            if (!maxSuggestPrice && minSuggestPrice) {
              price = minSuggestPrice;
            }
            return h('div', [
              h('p', price),
              h('p', '(' + v.currencyState + ')')
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001091'),
          key: 'ymsAvailableNumber',
          minWidth: 110,
          align: 'center',
          render(h, params) {
            let number = params.row.ymsAvailableNumber || 0;
            return h('span', number);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001102'),
          key: 'supplierAvailableNumber',
          minWidth: 110,
          align: 'center',
          render(h, params) {
            let number = params.row.supplierAvailableNumber || 0;
            return h('span', number);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          width: 120,
          fixed: 'right',
          align: 'center',
          key: 'options',
          render: (h, params) => {
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000402'),
                    show: true,
                    clickFn: () => {
                      v.currentObj = params;
                      v.removalType = 'single';
                      v.promptBoxModal = true;
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        },
      ],
      tableData: [],
      pageParams: {
        searchValue: '',
        ymsSpus: [],
        supplierSpus: [],
        ymsProductCategoryIdList: [],
        ymsProductIds: [],
        type: 1
      },
      configureMatchingRulesModal: false,
      configureMatchingRulesForm: {
        matchRuleType: null,
        matchRuleValue: null
      },
      matchingRulesList: [
        {value: 0, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005081')}
      ],
      configureValidate: {
        matchRuleType: [
          {type: 'number', required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005082'), trigger: 'change'}
        ],
        matchRuleValue: [
          {type: 'number', required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005083'), trigger: 'change'}
        ],
      },
      ymsActivityPlanId: null,
      ymsActivityType: 'add',
      promptBoxModal: false,
      removalType: '',
      currentObj: {},
      ymsProductIdList: [],
      labelRander: (params, type) => {
        let name = params.title;
        let obj = {
          activityTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005084') + name + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002424'),
          activitySlogan: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005084') + name + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005085'),
          activityGoodsLabel: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005086') + name + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001442'),
          imagePath: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005084') + name + 'Banner：'
        };
        return obj[type];
      },
      enumData: []
    };
  },
  computed: {
    pageTableData() {
      let start = (this.page.pageNum - 1) * this.page.pageSize;
      let end = (this.page.pageNum - 1) * this.page.pageSize + this.page.pageSize;
      this.tableLoading = false;
      return this.tableData.slice(start, end);
    },
    // 设置标语宽度
    setSloganLabelWidth() {
      return isChineseLanguage() ? 150 : 190;
    },
    // 设置标签宽度
    setLabelWidth() {
      return isChineseLanguage() ? 150 : 215;
    },
    // 活动商品规则
    matchRuleList() {
      const ENUM_KEY = 'YmsActivityPlanMatchRuleCoreEnum';
      return getEnumList(this.enumData, ENUM_KEY, 'number');
    }
  },
  created() {
    this.initData();
  },
  methods: {
    formatterNumber,
    // 初始化数据
    async initData() {
      let enumKeyList = ['YmsActivityPlanMatchRuleCoreEnum'];
      this.enumData = await getDataSetBatchList(enumKeyList);
      let keyList = ['activityTitle_', 'activitySlogan_', 'activityGoodsLabel_', 'imagePath_'];
      this.initMultilingualFields('activityInfo', this.activityInfo, keyList);
      this.ymsActivityType = this.$route.query.type;
      if (this.ymsActivityType === 'edit') {
        this.ymsActivityPlanId = this.$route.query.ymsActivityPlanId;
        this.getActivityDetails();
      }
      this.$nextTick(() => {
        this.$refs['languagesTab'].tabName = this.languagesVal;
      });
    },
    localChangePage(page) {
      let v = this;
      v.page.pageNum = page;
    },
    localChangePageSize(pageSize) {
      this.setPageSizeStorage(pageSize);
      this.page.pageSize = pageSize;
      this.tableLoading = true;
    },
    // 获取活动详情的数据
    getActivityDetails() {
      let v = this;
      v.axios.get(api.get_ymsActivityPlan_detail + v.ymsActivityPlanId, {loading: true}).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            let {activityTitle, activitySlogan, activityGoodsLabel, imagePath, ...params} = data;
            let keylist = ['activityTitle', 'activitySlogan', 'activityGoodsLabel', 'imagePath'];
            let obj = v.handleMultilingualFormFields(data, keylist);
            v.activityInfo = Object.assign({}, params, obj);
            v.activityInfo.activityStartTime = v.$uDate.dealTime(data.activityStartTime, 'fulltime');
            v.activityInfo.activityEndTime = v.$uDate.dealTime(data.activityEndTime, 'fulltime');
            v.configureMatchingRulesForm.matchRuleType = data.matchRuleType;
            v.configureMatchingRulesForm.matchRuleValue = data.matchRuleValue;
            v.activityInfo.matchRuleDays = data.matchRuleValue;
            v.activityPricing.uniformPrice = data.uniformPrice;
            v.activityPricing.uniformPriceValue = data.uniformPriceValue;
            v.matchingRulesList.map((item) => {
              if (item.value === data.matchRuleType) {
                v.activityInfo.matchRuleTypeName = item.name;
              }
            });
            if (data.ymsProductIds) {
              v.pageParams.ymsProductIds = data.ymsProductIds;
              v.page.pageNum = 1;
              v.getList();
            }
          }
        }
      });
    },
    // 校验活动结束时间
    validateActivityTime() {
      let v = this;
      return function (rule, value, callback) {
        if (v.activityInfo.effectivenessStatus === 0) {
          if (!value) {
            return callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005087')));
          } else {
            callback();
          }
        }
        callback();
      };
    },
    // 选择活动开始、结束时间
    selectDate(val, type) {
      let v = this;
      if (!val) return;
      if (type === 'start') {
        v.startTime = val;
        v.endTime = null;
        v.activityInfo.activityEndTime = null;
      } else if (type === 'end') {
        v.endTime = val;
      }
      v.handleHideTime(type, val);
    },
    // 重置活动开始、结束时间
    resetDate(type) {
      let v = this;
      if (type === 'start') {
        v.activityInfo.activityStartTime = null;
        v.activityInfo.activityEndTime = null;
      } else {
        v.activityInfo.activityEndTime = null;
      }
    },
    // 处理禁用时分秒时间
    handleHideTime(type, val) {
      let v = this;
      v.timePickerOptions = {
        disabledHours: [],
        disabledMinutes: [],
        disabledSeconds: []
      };
      if (val) {
        let allHours = [];
        let allMinutes = [];
        for (let i = 0; i < 24; i++) {
          allHours.push(i);
        }
        for (let i = 0; i < 60; i++) {
          allMinutes.push(i);
        }
        if (allHours.length > 0 || allMinutes.length > 0) {
          let startDate = new Date(v.startTime);
          let startHours = startDate.getHours();
          let startMinutes = startDate.getMinutes();
          let startSeconds = startDate.getSeconds();
          let startTime = v.$uDate.getDateTime(v.startTime);

          let endDate = new Date(v.endTime);
          let endHours = endDate.getHours();
          let endMinutes = endDate.getMinutes();
          let endSeconds = endDate.getSeconds();
          let endTime = v.$uDate.getDateTime(v.endTime);
          // 判断是否选中的是同一天
          if (startTime === endTime) {
            v.timePickerOptions.disabledHours = allHours.filter((item) => {
              return item <= startHours;
            });
            v.timePickerOptions.disabledMinutes = allMinutes.filter((item) => {
              return item <= startMinutes;
            });
            v.timePickerOptions.disabledSeconds = allMinutes.filter((item) => {
              return item <= startSeconds;
            });
          }
        }
      }
    },
    // 限制上传的文件不能超过20M
    handleMaxSize(file) {
      let v = this;
      v.$Message.error({
        content: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000030')}${file.name}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000031')} ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000032')}`,
        duration: 5
      });
    },
    // 上传图片成功
    uploadSuccess(response, file, fileList, item) {
      let v = this;
      if (response.code === 0) {
        v.activityInfo['imagePath_' + item.code] = response.datas[0];
        v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000251'));
        v.$forceUpdate();
      } else {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000457'));
      }
    },
    // 取消按钮
    activityCancelBtn() {
      this.$router.push('/activityManage');
    },
    // 监听选中的商品
    updateGoodsData(data) {
      let v = this;
      if (data && data.length > 0) {
        let newList = v.uniqueFunc(data, 'ymsProductId');
        if (newList.length > 0) {
          let ymsProductIds = newList.map((item) => {
            return item.ymsProductId;
          });
          if (ymsProductIds.length > 0) {
            v.pageParams.ymsProductIds = ymsProductIds;
            v.page.pageNum = 1;
            v.getList();
          }
        }
      }
    },
    // 处理新增、编辑活动的参数
    handleParam() {
      let v = this;
      let talg = true;
      let {matchRuleTypeName, matchRuleDays, ...obj} = v.activityInfo;
      let keyList = ['activityTitle_', 'activitySlogan_', 'activityGoodsLabel_', 'imagePath_'];
      let params = v.handleMultilingualMultipleParam(obj, keyList);
      let query = Object.assign({}, params, v.activityPricing, v.configureMatchingRulesForm);
      query.activityStartTime = v.$uDate.getUniversalTime(new Date(v.activityInfo.activityStartTime).getTime(), 'fulltime');
      query.activityEndTime = v.$uDate.getUniversalTime(new Date(v.activityInfo.activityEndTime).getTime(), 'fulltime');
      if (query.uniformPriceValue) {
        query.uniformPrice = 1;
      } else {
        query.uniformPrice = 0;
      }
      // 校验参数---指定商品
      if (v.activityInfo.matchRule === 0) {
        if (v.tableData.length <= 0) {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005088'));
          talg = false;
          return false;
        } else {
          query.ymsProductIds = v.tableData.map((item) => {
            return item.ymsProductId;
          });
          query.matchRuleType = null;
          query.matchRuleValue = null;
        }
      }
      // 校验参数---配置规则匹配
      else if (v.activityInfo.matchRule === 1) {
        v.$refs['configureMatchingRulesForm'].validate(valid => {
          if (valid) {
            query.ymsProductIds = [];
          } else {
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005089'));
            talg = false;
            return false;
          }
        });
      }
      // 校验活动价
      if (v.activityPricing.uniformPrice) {
        if (!v.activityPricing.uniformPriceValue) {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005090'));
          talg = false;
          return false;
        }
      }
      if (v.ymsActivityType === 'add') {
        query.status = 0;
      } else {
        query.status = 1;
        query.ymsActivityPlanId = v.ymsActivityPlanId;
      }
      let start = new Date(query.activityStartTime).getTime();
      let end = new Date(query.activityEndTime).getTime();
      let now = new Date().getTime();
      // 判断活动结束时间是否小于当前时间
      if (v.activityInfo.effectivenessStatus === 0) {
        if (end < now) {
          query.status = 2;
        }
        if (end < start) {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005091'));
          return false;
        }
      }
      if (start > now) {
        query.status = 0;
      } else {
        query.status = 1;
      }
      return talg ? query : false;
    },
    // 保存按钮
    activityBtn() {
      let v = this;
      let url = '';
      let method = '';
      let text = '';
      // 新增
      if (v.ymsActivityType === 'add') {
        url = api.post_ymsActivityPlan_save;
        method = 'post';
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000456');
      }
      // 编辑
      else if (v.ymsActivityType === 'edit') {
        url = api.put_ymsActivityPlan_update;
        method = 'put';
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002279');
      }
      v.$refs['activityInfo'].validate(valid => {
        if (valid) {
          if (v.handleParam()) {
            v.axios[method](url, v.handleParam(), {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
              if (response.data.code === 0) {
                v.$Message.success(text);
                v.activityCancelBtn();
              }
            });
          }
        }
      });
    },
    // 勾选列表数据
    tableChange(data) {
      this.ymsProductIdList = [];
      if (data) {
        this.ymsProductIdList = data;
      }
    },
    // 配置匹配规则确定按钮
    configureMatchingRulesBtn() {
      let v = this;
      v.$refs['configureMatchingRulesForm'].validate(valid => {
        if (valid) {
          let type = v.configureMatchingRulesForm.matchRuleType;
          v.matchingRulesList.map((item) => {
            if (item.value === type) {
              v.activityInfo.matchRuleTypeName = item.name;
            }
          });
          v.activityInfo.matchRuleDays = v.configureMatchingRulesForm.matchRuleValue;
          v.configureMatchingRulesModal = false;
        }
      });
    },
    // 移除商品的操作按钮
    removalBtn(type) {
      this.removalType = type;
      this.promptBoxModal = true;
    },
    // 移除商品的确定按钮
    promptBoxBtn() {
      let v = this;
      let newList = v.ymsProductIdList.map((item) => {
        return item.ymsProductId;
      });
      if (this.removalType === 'all') {
        let ymsProductIds = v.tableData.map((item) => {
          if (!newList.includes(item.ymsProductId)) {
            return item.ymsProductId;
          }
        });
        v.pageParams.ymsProductIds = ymsProductIds;
        v.page.pageNum = 1;
        v.getList();
      } else {
        let ymsProductIds = v.tableData.map((item) => {
          if (v.currentObj.row.ymsProductId !== item.ymsProductId) {
            return item.ymsProductId;
          }
        });
        v.pageParams.ymsProductIds = ymsProductIds;
        v.page.pageNum = 1;
        v.getList();
      }
      v.promptBoxModal = false;
    },
    // 获取活动商品的数据
    getList() {
      let v = this;
      v.tableLoading = true;
      v.tableData = [];
      v.axios.post(api.post_ymsProductInfo_queryYmsProductListInfo, v.pageParams).then(response => {
        v.tableLoading = false;
        if (response.data.code === 0) {
          v.pageParams.ymsProductIds = [];
          let data = response.data.datas || [];
          if (data.length > 0) {
            let keyList = ['supplierMerchantIdName', 'name'];
            v.tableData = v.handleMultilinguaTableFields(data, keyList);
            v.updateTableDom('selection');
          }
        }
      });
    },
    // 添加商品操作按钮
    addGoodsBtn() {
      this.$refs['addCommonProduct'].initFun();
      this.$refs['addCommonProduct'].selectTableData = this.tableData;
    },
    // 设置表单必填项校验规则
    getRules(item) {
      let list = [];
      if (item.required) {
        list = [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005084') + item.title + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002427'), trigger: 'blur'}
        ];
      }
      return list;
    },
  },
  watch: {
    // 监听是否设置了活动结束时间长期有效
    'activityInfo.effectivenessStatus': {
      handler(value) {
        if (value === 1) {
          this.activityInfo.activityEndTime = null;
        }
      },
      immediate: true,
      deep: true
    },
    'activityInfo.isShowSupplierInfo': {
      handler(value) {
        if (value === 0) {
          this.activityInfo.matchRule = 0;
        }
      },
      immediate: true,
      deep: true
    }
  },
  components: {
    languagesTabs,
    addCommonProductModal
  }
};
</script>

<style lang="less" scoped>
.container_box {
  padding-bottom: 50px;

  .form_box_style {
    width: 100%;

    /deep/ .ivu-form-item-label {
      font-size: 14px !important;
    }

    .img_style {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 10px;
    }

    .tips_txt {
      margin-left: 6px;
      color: #d00707;
    }

    .activity_longTerm_style {
      display: flex;
      align-items: center;
    }

    .tooltip_styles {
      position: relative;

      /deep/ .ivu-tooltip {
        position: absolute;
        top: 7px;
        cursor: pointer;
      }

      /deep/ .slogan_tips {
        left: 37px;
      }

      /deep/ .activityLabel_tips {
        left: 9px;
      }
    }
  }

  .options_content {
    box-shadow: 0px -3px 10px 0px #c9cbce;
    position: fixed;
    min-width: 100%;
    z-index: 10;
    background-color: #fff;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 10px 15px;
  }
}
</style>
